import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { ApiOptionsInterface } from './api.interface';
import { Buffer } from "buffer";

import { ApiRestService } from './api-rest.service';
@Injectable({
  providedIn: 'root'
})
export class ApiFlightlogService extends ApiRestService {

  relativeUrl = '/flightlog';
  encode = (str: string):string => Buffer.from(str, 'binary').toString('base64');

  constructor(http: HttpClient) { super(http); }

  public getTrip(options?: ApiOptionsInterface): Observable<any> {
    if(!options?.params.hasOwnProperty('url')) {
      console.error('Missing url parameter');
      return new Observable();
    }
    options.params['url'] = this.encode(options.params['url']);
    return this.getList(this.relativeUrl + '/trip', options);
  }

  public getKml(options?: ApiOptionsInterface): Observable<any> {
    if(!options?.params.hasOwnProperty('url')) {
      console.error('Missing url parameter');
      return new Observable();
    }
    options.params['url'] = this.encode(options.params['url']);
    return this.getList(this.relativeUrl + '/kml', options);
  }

  public getStart(startId: number, countryId: number = 160, options?: ApiOptionsInterface): Observable<any> {
    return this.getList(this.relativeUrl + '/start/' + countryId + '/' + startId, options);
  }

}